module.exports = __webpack_public_path__ + "img/avatar-30.c2586da2.svg";